import styled from 'styled-components';
import { ListDataProps } from '../../../components/list/data';
import List from '../../../components/list/List';
import { useState } from 'react';
import AddInterestItemModal from '../../../components/modal/AddInterestItem';

function RecommendList({ listData }: { listData: ListDataProps[] }) {
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [mode, setMode] = useState<string>('add');

  return (
    <Container>
      <Title>이 알고리즘 추천물건</Title>
      <List
        compact
        page="search"
        data={listData}
        loading={false}
        setMode={setMode}
        setSelectedIdx={setSelectedIdx}
        setShowLikeModal={setShowLikeModal}
        setSelectedItem={() => {}}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
      {showLikeModal && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={selectedIdx}
          mode={mode}
          setActiveItem={setActiveItem}
        />
      )}
    </Container>
  );
}

export default RecommendList;

const Container = styled.div`
  display: flex;
  padding: 24px 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  background-color: #fff;
`;

const Title = styled.div`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;
